import type { WeekEvent } from "@rally/ui-kit";

export function upcomingInView(events: WeekEvent[], from: Date, to: Date, now: Date): WeekEvent[] {
  const lower = Math.max(from.getTime(), now.getTime());
  const upper = to.getTime();
  if (lower >= upper) return [];
  return events
    .filter((event) => {
      const start = new Date(event.startsAt).getTime();
      const end = event.endsAt ? new Date(event.endsAt).getTime() : start;
      return start < upper && (start >= lower || end > lower);
    })
    .sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime())
    .slice(0, 30);
}
